<div class="header-actions">
    <h2 class="section-title">User Management</h2>
    <button mat-flat-button color="primary" (click)="openRegisterDialog()">
        <mat-icon>add</mat-icon> Add User
    </button>
</div>

<div class="table-container mat-elevation-z2">
    <table mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>

        <ng-container matColumnDef="authority">
            <th mat-header-cell *matHeaderCellDef> Authority </th>
            <td mat-cell *matCellDef="let element">
                <span class="badge" [class.admin]="element.authority === 'admin' || element.authority === '管理者'">
                    {{element.authority}}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button color="primary" (click)="openEditDialog(element)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteUser(element)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div *ngIf="dataSource.length === 0" class="no-data">
        No users found or loading...
    </div>
</div>